// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.topImgPane .el-upload-list--picture-card .el-upload-list__item {\r\n  width: 380px;\n}\r\n", ""]);
// Exports
module.exports = exports;
